import app from '../../common/app';
import Component from '../Component';
import Icon from './Icon';
import LoadingIndicator from './LoadingIndicator';
import classList from '../utils/classList';
import Button from './Button';
export default class Input extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view(vnode) {
    const {
      className: inputClassName,
      ...inputAttrs
    } = this.attrs.inputAttrs || {};
    const value = this.attrs.value || this.attrs.stream?.() || '';
    return m("div", {
      className: classList('Input', this.attrs.className, {
        'Input--withPrefix': this.attrs.prefixIcon,
        'Input--withClear': this.attrs.clearable
      })
    }, this.attrs.prefixIcon && m(Icon, {
      name: classList(this.attrs.prefixIcon, 'Input-prefix-icon')
    }), this.input({
      inputClassName,
      value,
      inputAttrs
    }), this.attrs.loading ? m(LoadingIndicator, {
      size: "small",
      display: "inline",
      containerClassName: "Button Button--icon Button--link"
    }) : null, this.attrs.clearable && value && !this.attrs.loading ? m(Button, {
      className: "Input-clear Button Button--icon Button--link",
      onclick: e => {
        e.stopPropagation();
        this.clear();
      },
      "aria-label": this.attrs.clearLabel || app.translator.trans('core.lib.input.clear_button'),
      type: "button",
      icon: "fas fa-times-circle"
    }) : null);
  }
  input({
    inputClassName,
    value,
    inputAttrs
  }) {
    const attrs = {
      className: classList('FormControl', inputClassName),
      type: this.attrs.type || 'text',
      value: value,
      oninput: e => this.onchange?.(e.target.value),
      'aria-label': this.attrs.ariaLabel,
      placeholder: this.attrs.placeholder,
      readonly: this.attrs.readonly || undefined,
      disabled: this.attrs.disabled || undefined,
      ...inputAttrs
    };
    if (this.attrs.renderInput) {
      return this.attrs.renderInput(attrs);
    }
    return m("input", attrs);
  }
  onchange(value) {
    if (this.attrs.stream) {
      this.attrs.stream(value);
    } else {
      this.attrs.onchange?.(value);
    }
  }
  clear() {
    this.onchange('');
  }
}
flarum.reg.add('core', 'common/components/Input', Input);